// extracted by mini-css-extract-plugin
export default {"panel":"hlbYn3uyZ1GJ2BeSFypG"};